<template>
  <wrap-container>
    <help-title title="Autorización de compras" />

    <help-list-container>
      <help-list-item tituloLista="Realizar una compra:">
        Si al querer realizar una compra tu tarjeta fue rechazada, o te solicita
        una autorización, comunicate con la marca de tu Tarjeta para dar aviso.
        Te realizarán consultas específicas para confirmar tu identidad y
        habilitar la compra.
        <br />
        <br />
        <strong>MasterCard</strong> <br />
        - Infoline: 4348-7000 <br />
        - Goldline: 4348-7007 <br />
        - Platinum Line: 0800-999-3999 <br />
        - Black Line: 0800-999-3297 <br />
        Desde el exterior comunicate con Masterassist al (5411) 4800-0810
        (solicitando a la operadora local la llamada con cobro revertido a
        Argentina).
        <br />
        <br />
        <strong>Visa</strong><br />
        - Classic: 4379-3400 (Capital y GBA), 0810-666-3400 (resto del país)<br />
        - Gold: 4378-4444 (Capital y GBA), 0810-666-4653 (resto del país)<br />
        - Platinum: 0800-333-7528<br />
        - Signature: 0800-222-7446<br />
        - Banelco: 4320-2500 (Lunes a Viernes de 8:00 a 20:00 hs.)
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
